import type { GymMember, GymMemberPayload } from '../../types/gym-member';

/** A blank roster row, for the create form. */
export const emptyGymMemberForm: GymMemberPayload = {
  name: '',
  surname: '',
  email: '',
  phone: '',
  birth_date: '',
  fiscal_code: '',
  medical_certificate_expires_at: '',
  notes: '',
};

/**
 * Turns a saved member into the shape the form edits. Nulls become empty
 * strings so every input stays controlled.
 */
export function toGymMemberForm(member: GymMember): GymMemberPayload {
  return {
    name: member.name,
    surname: member.surname ?? '',
    email: member.email ?? '',
    phone: member.phone ?? '',
    birth_date: member.birth_date ?? '',
    fiscal_code: member.fiscal_code ?? '',
    medical_certificate_expires_at: member.medical_certificate_expires_at ?? '',
    notes: member.notes ?? '',
  };
}
